import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TabService {
  constructor() {}
  activeTabKey = 'activeTabIndex';

  setActiveTab(index: number): void {
    localStorage.setItem(this.activeTabKey, index.toString());
  }

  getActiveTab(): number {
    const savedIndex = localStorage.getItem(this.activeTabKey);
    return savedIndex ? parseInt(savedIndex, 10) : 0; // Default to the first tab
  }
  resetActiveTab(): void {
    localStorage.removeItem(this.activeTabKey);
  }
}
